import React from 'react';
import './Chip.css';

interface ChipProps {
    text: string;
    onRemove: () => void;
}

const Chip: React.FC<ChipProps> = ({ text, onRemove }) => {
    return (
        <div className="chip">
            <span>{text}</span>
            <button onClick={onRemove} className="chip-button">
                X
            </button>
        </div>
    );
};

export default Chip;
